/**
 * Petits composants partagés des rapports comptables.
 */
import { money } from "../_shared";

export function Card({ title, right, children, testId }) {
  return (
    <div className="bg-white border rounded-xl overflow-hidden" data-testid={testId}>
      <div className="px-4 py-2 border-b bg-slate-50 flex items-center justify-between gap-2 flex-wrap">
        <span className="text-xs font-bold uppercase tracking-wide text-slate-700">{title}</span>
        {right && <span className="text-xs text-slate-600">{right}</span>}
      </div>
      {children}
    </div>
  );
}

export function Table({ children }) { return <table className="w-full text-sm">{children}</table>; }

export const TH = ({ children, right, className = "" }) => <th className={`px-3 py-2 ${right ? "text-right" : "text-left"} ${className}`}>{children}</th>;
export const THead = ({ children }) => <thead className="bg-slate-50 text-[10px] uppercase tracking-wider text-slate-500"><tr>{children}</tr></thead>;
export const Num = ({ v, blankZero = true, className = "", testId }) => <td className={`px-3 py-1.5 text-right font-mono tabular-nums ${className}`} data-testid={testId}>{blankZero && !v ? "" : money(v)}</td>;

export function Banner({ ok, label, value, testId }) {
  return (
    <div className={`rounded-xl border-2 p-4 flex items-center justify-between gap-3 flex-wrap ${ok ? "bg-emerald-50 border-emerald-200 text-emerald-900" : "bg-rose-50 border-rose-200 text-rose-900"}`} data-testid={testId}>
      <span className="font-bold uppercase text-xs tracking-wide">{label}</span>
      <span className="text-xl font-bold font-mono tabular-nums">{value}</span>
    </div>
  );
}

/** Lignes montant simple (N°, nom, montant) + total. */
export function Rows({ rows, label, total, testId }) {
  return (
    <tbody className="divide-y" data-testid={testId}>
      {rows.map((r) => (
        <tr key={r.account_id || r.name} className="hover:bg-emerald-50/40">
          <td className="px-3 py-1.5 font-mono text-xs w-16">{r.number}</td>
          <td className="px-3 py-1.5">{r.name}</td>
          <Num v={r.amount} blankZero={false} />
        </tr>
      ))}
      <tr className="bg-slate-50 font-bold"><td></td><td className="px-3 py-2 uppercase text-xs">{label}</td><Num v={total} blankZero={false} /></tr>
    </tbody>
  );
}

/** Lignes comparatives (exercice courant / précédent). */
export function CmpRows({ rows, extra = [], label, totals, testId }) {
  return (
    <tbody className="divide-y" data-testid={testId}>
      {rows.map((r) => (
        <tr key={r.account_id} className="hover:bg-emerald-50/40">
          <td className="px-3 py-1.5 font-mono text-xs w-16">{r.number}</td>
          <td className="px-3 py-1.5">{r.name}</td>
          <Num v={r.current} blankZero={false} /><Num v={r.prior} blankZero={false} className="text-slate-500" />
        </tr>
      ))}
      {extra.filter((r) => r.current || r.prior).map((r) => (
        <tr key={r.name} className="hover:bg-emerald-50/40 italic">
          <td></td><td className="px-3 py-1.5">{r.name}</td>
          <Num v={r.current} blankZero={false} /><Num v={r.prior} blankZero={false} className="text-slate-500" />
        </tr>
      ))}
      <tr className="bg-slate-50 font-bold"><td></td><td className="px-3 py-2 uppercase text-xs">{label}</td><Num v={totals.current} blankZero={false} /><Num v={totals.prior} blankZero={false} className="text-slate-500" /></tr>
    </tbody>
  );
}
